import { t } from "./utils/translations/phrases";

/** What a player sees about their entry payment: one plain line, and a tone for its colour (paid, waiting, problem). */
export type PaymentTone = "ok" | "wait" | "bad";

export const paymentStatus = (state: string, price: string): [string, PaymentTone] => {
	switch (state) {
		case "pending":
			return [t("Pay <price> to join the next round.", { price }), "wait"];
		case "confirming":
			return [t("Checking your <price> payment on the blockchain…", { price }), "wait"];
		case "confirmed":
			return [`✓ ${t("Paid <price>. You're in the next round.", { price })}`, "ok"];
		case "consumed":
			return [`✓ ${t("Paid <price>. That round has started or finished.", { price })}`, "ok"];
		case "expired":
			return [t("This payment request expired before it was paid."), "bad"];
		case "cancelled":
			return [t("This payment was cancelled."), "bad"];
		case "refund_pending":
			// (not "on its way": a refund an admin sends waits for them, as the notice on leaving says)
			return [t("Your <price> is to be refunded, to the wallet that paid it.", { price }), "wait"];
		case "refunded":
			return [`✓ ${t("Refunded <price>.", { price })}`, "ok"];
		default:
			return [t("Payment: <state>.", { state: state.replaceAll("_", " ") }), "wait"];
	}
};
